export default "__VITE_ASSET__Di7Ozxdd__"